module.exports = __webpack_public_path__ + "img/file_edit_holdback.1d49b662.png";